import { Button, Empty, Spin } from "antd";
import { ContactAvatar } from "./ContactAvatar";
import type { ThreadSummary } from "../api/threads";
import { relativeTime } from "../utils/time";

type Props = {
  threads: ThreadSummary[];
  selectedId: string | null;
  loading?: boolean;
  hasMore?: boolean;
  loadingMore?: boolean;
  onSelect: (id: string) => void;
  onLoadMore?: () => void;
};

export function ThreadList({
  threads,
  selectedId,
  loading,
  hasMore,
  loadingMore,
  onSelect,
  onLoadMore,
}: Props) {
  if (loading && threads.length === 0) {
    return (
      <div style={{ padding: 32, display: "grid", placeItems: "center" }}>
        <Spin />
      </div>
    );
  }
  if (threads.length === 0) {
    return (
      <div style={{ padding: 32 }}>
        <Empty description="暂无邮件" />
      </div>
    );
  }
  return (
    <ul
      style={{
        listStyle: "none",
        margin: 0,
        padding: 0,
        height: "100%",
        overflowY: "auto",
      }}
    >
      {threads.map((t) => {
        const active = selectedId === t.id;
        return (
          <li key={t.id}>
            <button
              type="button"
              onClick={() => onSelect(t.id)}
              style={{
                width: "100%",
                display: "flex",
                gap: 12,
                alignItems: "flex-start",
                padding: "14px 16px",
                border: "none",
                borderBottom: "1px solid var(--ant-color-border)",
                background: active
                  ? "color-mix(in srgb, var(--ant-color-primary) 10%, transparent)"
                  : "transparent",
                textAlign: "left",
                cursor: "pointer",
                color: "inherit",
                minHeight: 72,
              }}
            >
              {t.from ? (
                <ContactAvatar email={t.from.email} name={t.from.name} tier={t.from.tier} size={40} />
              ) : null}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 8,
                  }}
                >
                  <span
                    style={{
                      fontWeight: t.isRead ? 500 : 700,
                      fontSize: 16,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {t.from?.name || t.from?.email || "未知发件人"}
                  </span>
                  <span
                    style={{
                      fontSize: 13,
                      color: "var(--ant-color-text-secondary)",
                      flexShrink: 0,
                    }}
                  >
                    {relativeTime(t.lastMessageAt)}
                  </span>
                </div>
                <div
                  style={{
                    fontSize: 15,
                    fontWeight: t.isRead ? 400 : 600,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    marginTop: 2,
                  }}
                >
                  {t.subject || "(无主题)"}
                </div>
                <div
                  style={{
                    fontSize: 14,
                    color: "var(--ant-color-text-secondary)",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    marginTop: 2,
                  }}
                >
                  {t.snippet}
                </div>
              </div>
              {!t.isRead ? (
                <span
                  style={{
                    width: 8,
                    height: 8,
                    borderRadius: "50%",
                    background: "var(--ant-color-primary)",
                    marginTop: 8,
                    flexShrink: 0,
                  }}
                />
              ) : null}
            </button>
          </li>
        );
      })}
      {hasMore ? (
        <li style={{ padding: 12, textAlign: "center" }}>
          <Button block loading={loadingMore} onClick={onLoadMore}>
            加载更多
          </Button>
        </li>
      ) : null}
    </ul>
  );
}
